import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { Box, Button, Text } from '@components/common';
import { InputField } from '@components/form';
import API from '@utils/api';
import { getErrors } from '@utils/error';
import validationSchema from './schema';

import SignupActions, {
  SIGNUP_STAGE,
  SignupSelectors
} from '@redux/SignupRedux';
import { trackEmailEntered } from '@services/analytics';

class SignupForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onNext: PropTypes.func,
    initialFormValues: PropTypes.object
  };

  handleSubmit = async (values, actions) => {
    const { onSubmit, onNext } = this.props;
    const { setSubmitting, setErrors } = actions;
    setSubmitting(true);

    try {
      await API.checkEmailAvailability(values);
      setSubmitting(false);
      onSubmit(values);
      trackEmailEntered(values);
      onNext();
    } catch (err) {
      const error = getErrors(err);
      const errors = {
        email: error.message || 'Email already exists'
      };

      setErrors(errors);
    }
    setSubmitting(false);
  };

  render() {
    const { initialFormValues } = this.props;
    return (
      <Formik
        initialValues={initialFormValues}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
        initialErrors={validationSchema.isValidSync(initialFormValues)}
      >
        {({ isValid, isSubmitting }) => {
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Text fontSize={1} mb={4} color="lightText">
                  Tell us about you
                </Text>
                <Field
                  component={InputField}
                  mb={4}
                  name="email"
                  type="email"
                  label="Email Address"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="password"
                  type="password"
                  label="Password"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="passwordConfirmation"
                  type="password"
                  label="Confirm Password"
                />
                <Button
                  flex={1}
                  mb={4}
                  type="submit"
                  disabled={!isValid || isSubmitting}
                >
                  Continue
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStatesToProps = state => ({
  initialFormValues: SignupSelectors.selectLoginInfo(state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => dispatch(SignupActions.setSignupLoginInfo(values)),
  onNext: () => dispatch(SignupActions.setSignupStep(SIGNUP_STAGE.CONTACT))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(SignupForm);
